export const ActionTypes = {
  SET_ORG: "app/redux/mgt-org/SET_ORG",
  ADD_ORG: "app/redux/mgt-org/ADD_ORG",
  UPDATE_ORG: "app/redux/mgt-org/UPDATE_ORG",
  DELETE_ORG: "app/redux/mgt-org/DELETE_ORG",
};
